import { Box, Stack, styled } from '@razz-team/ui-web';
import { AuthAbout } from './AuthAbout';
import { ReactNode } from 'react';

const AuthFormContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export function BrightyAuthLayout({ children }: { children: ReactNode }) {
  return (
    <Stack direction="row" width="100%" height="100vh">
      <Box width="50%" height="100%" display={{ xs: 'none', md: 'block' }}>
        <AuthAbout />
      </Box>
      <AuthFormContainer width={{ xs: '100%', md: '50%' }} height="100%">
        {children}
      </AuthFormContainer>
    </Stack>
  );
}
